module.exports = __webpack_public_path__ + "static/img/05.4830aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/05.jpg
// module id = 9Aap
// module chunks = 1